// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"49d307de","428":"d9741d90","445":"65450ca3","593":"dce47a50","670":"95cbbe0e","771":"d9e18142"}[chunkId] + ".chunk.css";
};